/* istanbul ignore file */

export const ROUTING_CONSTANTS = {
    ROUTING_TABS_INPUT: 'routingTabsInput',
    REPORT_DEFINITION_ID: 'reportDefinitionId',
};
